import { Component, OnInit } from '@angular/core';
import {FacetsService} from '../../../servies/Facets/facets.service';
import {SearchComponent} from  '../search.component'

@Component({
  selector: 'app-search-history',
  templateUrl: './search-history.component.html',
  styleUrls: ['./search-history.component.css']
})
export class SearchHistoryComponent implements OnInit {

  constructor(private Facets: FacetsService, private seach:SearchComponent) { }

  private Queylist:any
  public test:boolean
  private testlist:JSON
  private logged_in_username:string

  private md:QL

  ngOnInit() {
    this.logged_in_username= sessionStorage.getItem('loggedinname');
    this.test=false;
    this.Facets.fetchQryByName(this.logged_in_username).subscribe((data) =>  {
      this.Queylist = data ;
      if(this.Queylist.length>0){
        this.test=true;
      }
      
    });
    
  }

  select(id:number){
    console.log(id);
    this.seach.search(id);
  }

  delete(id:number){
    this.Facets.deleteQry(id).subscribe((data) =>  {
      console.log(data);
      this.ngOnInit();
    });

  }

  call(qid:any){
    this.test=true;
    console.log(this.Queylist);
    console.log(qid);
  }

}

interface QL{
  filters:string
  keyword:string
  createdDt:string
}
